<template>
    <div id="data-proyecto-list-view">
        <vx-card class="mb-base" no-shadow card-border>

            <div class="justify-between flex-grow vx-row">

                <div class="mt-2 vx-col mb-sm-0">
                    <feather-icon icon="FileIcon" class="mr-2" svgClasses="w-5 h-5" />
                    <span class="font-medium leading-none">Proyectos de Inversión Pública</span>
                </div>

            </div>

            <vs-divider/>
            
            <div class="flex flex-wrap items-center justify-start mb-6">
                <vs-button 
                    @click="actualizar" 
                    icon-pack="feather" 
                    color="rgb(62, 201, 214)" 
                    icon="icon-refresh-cw" 
                    class="ml-auto vs-con-loading__container" 
                    id="button-update-proyecto-with-loading"
                    >
                    Actualizar
                </vs-button>
            </div>
            <vs-table stripe ref="table" :data="itemsProyecto" pagination :max-items="itemsPerPage" search noDataText="No existen datos">
                <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
                    <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer items-per-page-handler">
                        <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsProyecto.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsProyecto.length }} de {{ itemsProyecto.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5">
                            <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                        
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th>CODIGO UNICO</vs-th>
                    <vs-th>NOMBRE DE LA INVERSION</vs-th>
                    <vs-th>COSTO DEL PROYECTO</vs-th>
                    <vs-th>PIM VIGENTE</vs-th>
                    <vs-th>AVANCE PIM(%)</vs-th>
                    <vs-th>ESTADO SITUACIONAL</vs-th>
                    <vs-th>UEI</vs-th>
                    <vs-th>FECHA ACT.</vs-th>
                    <vs-th>ACCIONES</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].cui">
                                <div @click="accessSsi(tr)" class="cursor-pointer">
                                    <vs-chip color="rgb(62, 101, 150)" transparent>
                                        <strong>
                                            <span class="text-bold">{{data[indextr].cui}}</span>
                                        </strong>
                                    </vs-chip>
                                </div>
                            </vs-td>
                            <vs-td :data="data[indextr].nombreInversion">
                                <span class="text-black text-bold">{{ data[indextr].nombreInversion }}</span>
                            </vs-td>
                            <vs-td :data="data[indextr].costo">
                                <strong>
                                    <span class="text-dark text-bold">{{ formatNumber(data[indextr].costo) }}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].pim">
                                <strong>
                                    <span class="text-warning text-bold">{{ formatNumber(data[indextr].pim) }}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].avance">
                                <vs-chip v-if="data[indextr].avance!==null" transparent color="danger">
                                    <strong>
                                        <span class="text-danger text-bold">{{ data[indextr].avance }}</span>
                                    </strong>
                                </vs-chip>
                            </vs-td>
                            <vs-td :data="data[indextr].estadoSituacional">
                                {{ data[indextr].estadoSituacional }}
                            </vs-td>
                            <vs-td :data="data[indextr].uei">
                                {{ data[indextr].uei != null ? data[indextr].uei.descripcion : '' }}
                            </vs-td>
                            <vs-td :data="data[indextr].fechaRegistro">
                                {{ data[indextr].fechaRegistro }}
                            </vs-td>
                            <vs-td :data="data[indextr].meta" class="whitespace-no-wrap">
                                <div class="vx-row-actions">
                                    <vx-tooltip text="Actualizar datos" position="bottom">
                                        <vs-button @click="update(tr)" class="ml-1" color="warning" type="filled" icon-pack="feather" icon="icon-refresh-cw" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Ver datos actualizados" position="bottom">
                                        <vs-button @click="edit(tr)" class="ml-1" color="rgb(62, 201, 214)" type="filled" icon-pack="feather" icon="icon-grid" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Ver ubicación" position="bottom">
                                        <vs-button @click="ubicacion(tr)" class="ml-1" color="success" type="filled" icon-pack="feather" icon="icon-map-pin" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Ver estado" position="bottom">
                                        <vs-button @click="estados(tr)" class="ml-1" color="danger" type="filled" icon-pack="feather" icon="icon-activity" size="small"></vs-button>
                                    </vx-tooltip>
                                    
                                </div>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>

            <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                <p class="text-sm truncate">
                    Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsProyecto.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsProyecto.length }}</strong> de un total de <strong>{{ itemsProyecto.length }}</strong> registros
                </p>
            </div>

        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select';
export default {
    components: {
        'v-select': vSelect
    },
    data(){
        return {
            itemsProyecto       : [],
            itemsPerPage        : 10,
            isMounted           : false,

            backgroundLoading   : 'primary',
            colorLoading        : '#fff',
        }
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    mounted () {
        this.isMounted = true;
        this.findAll();
    },

    methods: {

        findAll(){
            this.$vs.loading();
            this.$http.findAllProyectos()
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsProyecto = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        accessSsi(tr){
            window.open("https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=" + tr.cui, '_blank').focus();
        },

        update(tr){
            this.$vs.loading();
            this.$http.updateFromSSI(tr.cui)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.findAll();
                }
            })
            .catch(error => {
                this.$vs.loading.close();
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        actualizar(){
            this.$vs.loading({
                background: 'rgb(62, 201, 214)',
                color: this.colorLoading,
                container: "#button-update-proyecto-with-loading",
                scale: 0.45
            });

            this.$http.updateFromSiaf()
            .then(response => {
                this.$vs.loading.close("#button-update-proyecto-with-loading > .con-vs-loading")
                if(response.status === 200){
                    this.itemsProyecto = response.data;
                }
            })
            .catch(error => {
                this.$vs.loading.close("#button-update-proyecto-with-loading > .con-vs-loading")
                if(error.response === undefined){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'warning',
                        title: `Aviso`,
                        text: 'Ocurrio un error al realizar la consulta.',
                        acceptText: 'Aceptar',
                        accept: this.regresar
                    });
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        edit(tr){
            this.$router.push({
				name: 'app-parametro-proyecto-detalle',
				params: { id: tr.cui }
			}).catch(() => {});
        },

        ubicacion(tr){
            this.$router.push({
				name: 'app-parametro-proyecto-ubicacion',
				params: { id: tr.cui }
			}).catch(() => {});
        },

        estados(tr){
            this.$router.push({
				name: 'app-parametro-proyecto-estados',
				params: { id: tr.cui }
			}).catch(() => {});
        },

        formatNumber(num) {
            if(num === null) return "";
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
        },

        getOrderStatusColor (status) {
            if (status) return 'success'
            return 'danger'
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    }
}
</script>
<style lang="scss">
#data-proyecto-list-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

.vx-row-actions {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -1rem;

  & > .vx-col {
    padding: 0 1rem;
  }

  &.match-height>.vx-col {
    display: flex;
  }

  &.no-gutter {
    margin: 0;

    & > .vx-col {
      padding: 0;
    }
  }
}
</style>